export default __webpack_public_path__ + "static/media/breakerplace.dd87e131.jpg";